import {
  fetchEventService,
  fetchSingleEventService,
  fetchEventAdminService,
} from "./api";
import {
FETCH_EVENTS,
FETCH_EVENTS_FAILED,
FETCH_EVENTS_SUCCESSFUL,

FETCH_SINGLE_EVENTS,
FETCH_SINGLE_EVENTS_COMPLETE,
} from "./types";

export const fetchEventsAction = (params) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_EVENTS });
    const response = await fetchEventService(params);

    const { data: { stories }, headers: { total, per_page }} = response;
    dispatch({ type: FETCH_EVENTS_SUCCESSFUL, events: {
      data: stories,
      total,
      per_page
    } });
    return true;
  } catch (error) {
    dispatch({ type: FETCH_EVENTS_FAILED });
  }
};


export const fetchEventsForAdmin = (params) => async (dispatch) => {
  const{ token, ...rest} = params;
  try {
    dispatch({ type: FETCH_EVENTS });
    const response = await fetchEventAdminService(rest, token)();
    dispatch({ type: FETCH_EVENTS_SUCCESSFUL, events: response?.data });
    return true;
  } catch (error) {
    dispatch({ type: FETCH_EVENTS_FAILED });
  }
};

export const fetchSingleEventAction = (id) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_SINGLE_EVENTS });
    const response = await fetchSingleEventService(id);
    dispatch({ type: FETCH_SINGLE_EVENTS_COMPLETE });
    return response?.data.story;
  } catch (error) {
    dispatch({ type: FETCH_SINGLE_EVENTS_COMPLETE });
  }
};